import { inject } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { AuthService } from "../services/api/auth/auth.service";

export const authGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): boolean => {
  // Inject AuthService and Router
  const authService = inject(AuthService);
  const router = inject(Router);

  // Check whether the user login successfully
  if (authService.loggedIn) {
    // login
    return true;
  } else {
    router.navigate(["/login"]);
    return false;
  }
};
